import routerOptions0 from "/builds/webcontact/marxzell/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/builds/webcontact/marxzell/node_modules/@webcontact/nuxt-kommunen/dist/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}